import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DropzoneComponent from 'react-dropzone-component';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import PhotosList from '../PhotosList';

import { createListPhotos, removeListPhotos } from '../../actions/manageListPhotos';
import { userRestriction } from '../../helpers/DemoRestriction/demoRestriction';
import dropzoneErrors from '../../helpers/dropzoneErrors';
import showToaster from '../../helpers/showToaster';

import withStyles from 'isomorphic-style-loader/withStyles';

import t from 'dropzone/dist/min/dropzone.min.css';
import s from 'react-dropzone-component/styles/filepicker.css';
import cs from '../../styles/documentUploadDropzone.css';

class PhotosUpload extends Component {

  static propTypes = {
    createListPhotos: PropTypes.any.isRequired,
    removeListPhotos: PropTypes.any.isRequired,
    listId: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
    this.dropzone = null;
    this.state = {
      djsConfig: {}
    }
  }

  async componentDidMount() {
    const { placeholder, maxUploadSize } = this.props;
    const isBrowser = typeof window !== 'undefined';
    const isDocument = typeof document !== undefined;

    if (isBrowser && isDocument) {
      document.querySelector(".dz-hidden-input").style.visibility = 'visible';
      document.querySelector(".dz-hidden-input").style.opacity = '0';
      document.querySelector(".dz-hidden-input").style.height = '100%';
      document.querySelector(".dz-hidden-input").style.width = '100%';
      document.querySelector(".dz-hidden-input").style.cursor = 'pointer';
    }

    if (placeholder) {
      this.setState({
        djsConfig: {
          dictDefaultMessage: placeholder,
          addRemoveLinks: false,
          maxFilesize: maxUploadSize,
          maxFiles: 20,
          acceptedFiles: 'image/jpeg,image/png',
          hiddenInputContainer: '.dzInputContainer',
        }
      });
    }
  }

  UNSAFE_componentWillMount() {
    const { placeholder, maxUploadSize } = this.props;

    if (placeholder) {
      this.setState({
        djsConfig: {
          dictDefaultMessage: placeholder,
          addRemoveLinks: false,
          maxFilesize: maxUploadSize,
          maxFiles: 20,
          acceptedFiles: 'image/jpeg,image/png',
          hiddenInputContainer: '.dzInputContainer',
        }
      });
    }
  }

  handleButtonClick = () => {
    const hiddenInput = document.querySelector(".dz-hidden-input");
    if (hiddenInput) {
      hiddenInput.click();
    }
  };

  error = async (file) => {
    const { maxUploadSize } = this.props;
    dropzoneErrors(file, maxUploadSize);
    this.dropzone.removeFile(file);
  };

  complete = async (file) => {
    const { listId, createListPhotos, userRestriction } = this.props;

    const isRestrict = await userRestriction({ restrictType: 'listing', restrictValue: listId });
    if (isRestrict) {
      showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
      return;
    }

    let isOnline = typeof window !== 'undefined' && window.navigator.onLine;

    if (!isOnline) {
      showToaster({ messageId: 'offlineError', toasterType: 'error' })
      this.dropzone.removeFile(file);
      return;
    }
    if (file && file.xhr) {
      const { files } = JSON.parse(file.xhr.response);
      let fileName = files[0].filename;
      let fileType = files[0].mimetype;
      if (listId != undefined) {
        createListPhotos(listId, fileName, fileType);
      }
      this.dropzone.removeFile(file);
    }
  }

  render() {
    const { listId, maxUploadSize } = this.props;
    const { djsConfig } = this.state;

    const componentConfig = {
      iconFiletypes: ['.jpg', '.png'],
      postUrl: '/photos'
    };
    const eventHandlers = {
      init: dz => this.dropzone = dz,
      complete: this.complete,
      error: this.error,
    };

    return (
      <div className={cx('photoUploadWrapper')}>
        {/* Header del card */}
        <div className={cx('photoUploadHeader')}>
          <div className={cx('photoUploadHeaderText')}>
            <div className={cx('photoUploadTitleRow')}>
              <img
                src="/SiteIcons/foto.svg"
                alt=""
                className={cx('photoUploadTitleIcon')}
              />
              <div>
                <h3 className={cx('photoUploadTitle')}>Fotos del alojamiento</h3>
                <p className={cx('photoUploadSubtitle')}>
                  Sube imágenes que muestren los diferentes espacios y detalles {`\n`} de tu alojamiento. Esto ayudará a que los huéspedes tengan una {`\n`} mejor idea de lo que ofreces.
                </p>
              </div>
            </div>

          </div>
        </div>

        {/* Zona de dropzone */}
        <div className={cx('dzInputContainer', 'photoDropzoneArea')}>
          <DropzoneComponent
            config={componentConfig}
            eventHandlers={eventHandlers}
            djsConfig={djsConfig}
          >
            <div className={cx('photoDropzoneInner')}>
              <div className={cx('photoDropzoneIconWrap')}>
                <img
                  src="/SiteIcons/agregar-foto.svg"
                  alt=""
                  width="48"
                  height="48"
                />
              </div>
              <p className={cx('photoDropzoneLabel')}>Arrastra tus fotos aquí</p>
              <p className={cx('photoDropzoneHint')}>o selecciona desde tu dispositivo</p>
              <button
                type="button"
                className={cx('photoSelectBtn')}
                onClick={this.handleButtonClick}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '6px' }}>
                  <path d="M8 2v8M4 6l4-4 4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M2 12h12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                </svg>
                Seleccionar fotos
              </button>
            </div>
          </DropzoneComponent>
        </div>

        {/* Grid de fotos subidas */}
        <div className={cx('photoGridArea')}>
          <PhotosList listId={listId} onAddMore={this.handleButtonClick} />
        </div>

        {/* Nota informativa */}
        <div className={cx('photoUploadInfoNote')}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
            <circle cx="8" cy="8" r="7" stroke="#90A4AE" strokeWidth="1.5" />
            <path d="M8 7v5M8 5.5v.5" stroke="#90A4AE" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
          <span>Puedes subir hasta 20 fotos. Formatos permitidos: JPG, PNG. Tamaño máximo: {maxUploadSize || 10} MB por foto.</span>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  maxUploadSize: state?.siteSettings?.data?.maxUploadSize
});

const mapDispatch = {
  createListPhotos,
  removeListPhotos,
  userRestriction
};

export default injectIntl(withStyles(s, t, cs)(connect(mapState, mapDispatch)(PhotosUpload)));